import React from "react";
import { Link } from "react-router-dom";
import { Btn } from "../../styles/Button.styled";
import { IUser, UserAccount } from "../../interfaces/user";
import { AccountSwitcherItem } from "./AccountSwitcherItem";
import styles from "../../styles/Header.module.css";

interface HeaderPopupProps {
  isMobile: boolean;
  user: IUser;
  username: string[];
  switchAccount: (accountId: string) => void;
  setAccountMenu: (open: boolean) => void;
}

export const AccountSwitcher: React.FC<HeaderPopupProps> = ({
  user,
  username,
  switchAccount,
  setAccountMenu,
}) => {
  return (
    <ul>
      {user.accounts?.map((account: UserAccount) => {
        const isCurrentAccount = account.company.id === user.company.id;
        return (
          <li className={styles.account_item} key={account.id}>
            <AccountSwitcherItem
              account={account}
              permissions={user.permissions}
              isCurrentAccount={isCurrentAccount}
              username={username}
              switchAccount={switchAccount}
              setAccountMenu={setAccountMenu}
            />
          </li>
        );
      })}
      <li className={styles.exit}>
        <Link to="/logout">
          <Btn
            type="button"
            $background="var(--vivid-pink)"
            $width="100%"
            $heightMobile="46px"
          >
            Вихід
          </Btn>
        </Link>
      </li>
    </ul>
  );
};
